import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { cartAPI } from '../utils/api';
import { useAuth } from './AuthContext';
import toast from 'react-hot-toast';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], subtotal: 0, item_count: 0 });
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const fetchCart = useCallback(async () => {
    if (!user) { setCart({ items: [], subtotal: 0, item_count: 0 }); return; }
    try {
      setLoading(true);
      const { data } = await cartAPI.get();
      setCart(data);
    } catch {} finally { setLoading(false); }
  }, [user]);

  useEffect(() => { fetchCart(); }, [fetchCart]);

  const addItem = async (product_id, quantity = 1) => {
    if (!user) { toast.error('Duhet të kyçeni fillimisht'); return; }
    try {
      await cartAPI.add({ product_id, quantity });
      await fetchCart();
      toast.success('U shtua në shportë!');
      setOpen(true);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Gabim');
    }
  };

  const updateItem = async (id, quantity) => {
    try {
      await cartAPI.update(id, { quantity });
      await fetchCart();
    } catch {}
  };

  const removeItem = async (id) => {
    try {
      await cartAPI.remove(id);
      await fetchCart();
      toast.success('U hoq nga shporta');
    } catch {}
  };

  return (
    <CartContext.Provider value={{ cart, loading, open, setOpen, addItem, updateItem, removeItem, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
